export default __webpack_public_path__ + "static/media/comming-soon.2a74fcaa.png";